import { ENVIRONMENT } from "constants/environment";
import { useIsProductionSelector } from "hooks/selectors/useAppEnvironmentSelector";

export function useEnvironmentName() {
  const isProductionEnvironment = useIsProductionSelector();

  return isProductionEnvironment ? ENVIRONMENT.PRODUCTION : ENVIRONMENT.SANDBOX;
}
